export default "__VITE_ASSET__DTlfCLGL__"